import useDim from "src/hooks/useDim";
import { paddingLarge } from "src/styles/spacing";
import { TextInput } from "src/swsh-native";

const EditCoverAIPromptInput = ({
	initialValue,
	onChangeText,
	onSubmit,
	onFocusChange,
	autoFocus,
}: {
	initialValue: string;
	onChangeText?: (text: string) => void;
	onSubmit?: () => void;
	onFocusChange?: (isFocused: boolean) => void;
	autoFocus?: boolean;
}) => {
	const dim = useDim();
	return (
		<TextInput
			defaultValue={initialValue}
			style={{
				maxHeight: 200,
				padding: paddingLarge,
				flex: 1,
				minWidth: Math.min(0.9 * dim.width, 400),
			}}
			onChangeText={onChangeText}
			placeholder="Describe your perfect cover photo..."
			multiline
			autoFocus={autoFocus}
			autoCorrect
			autoCapitalize="sentences"
			onSubmitEditing={onSubmit}
			onFocus={() => onFocusChange?.(true)}
			onBlur={() => onFocusChange?.(false)}
		/>
	);
};
export default EditCoverAIPromptInput;
